import {GET_COMM} from '../data/comment_data'
import {ADD_TO_COMMENTS, ADD_TO_COMUPDS, DELETE_COMMENT} from './actions';
import CommentsModel from '../model/comments';
const initalState = {
  Comments:[]
}

const cloneComment = (item, extra = {}) => new CommentsModel(
  item.id,
  extra.content != null ? extra.content : item.content,
  item.postid,
  item.userid,
  item.date,
  item.userImg,
  item.email,
  extra.dCount != null ? extra.dCount : item.dCount,
  extra.pCount != null ? extra.pCount : item.pCount,
  extra.parentId !== undefined ? extra.parentId : item.parentId,
  extra.userVote !== undefined ? extra.userVote : item.userVote,
  extra.media !== undefined ? extra.media : item.media
)

export default (state=initalState,actions) =>{
  switch (actions.type) {
    case ADD_TO_COMMENTS:
    const comm = new CommentsModel(actions.id,actions.content,actions.postid,actions.userid,new Date().toISOString(),actions.img,actions.email,0,0,actions.parentId,null,actions.media)
     return{
       ...state,Comments:state.Comments.concat(comm)
     }
    case DELETE_COMMENT: {
      const removed = String(actions.id)
      return {
        ...state,
        Comments: state.Comments
          .filter(item => String(item.id) !== removed)
          .map(item => String(item.parentId) === removed ? cloneComment(item, { parentId: null }) : item)
      }
    }
    case ADD_TO_COMUPDS:
    return {
      ...state,
      Comments: state.Comments.map(item => {
        if (String(item.id) !== String(actions.commentId)) return item
        const pCount = Number(item.pCount) || 0
        const dCount = Number(item.dCount) || 0
        const was = item.userVote
        const type = actions.typee
        let nextP = pCount
        let nextD = dCount
        let nextVote = was
        if (was === type) {
          nextVote = null
          if (type === 'p') nextP = Math.max(0, pCount - 1)
          if (type === 'd') nextD = Math.max(0, dCount - 1)
        } else {
          nextVote = type
          if (was === 'p') nextP = Math.max(0, pCount - 1)
          if (was === 'd') nextD = Math.max(0, dCount - 1)
          if (type === 'p') nextP += 1
          if (type === 'd') nextD += 1
        }
        return cloneComment(item, { dCount: nextD, pCount: nextP, userVote: nextVote })
      })
    }
    case GET_COMM:
    return{
      ...state,Comments:actions.data
    }

  }
  return state;
}
